import { useEffect } from 'react';

interface PageHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
}

export default function PageHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
}: PageHeadProps) {
  useEffect(() => {
    const baseKeywords = '韩国漫画网, 韩国漫画网站, 韩国漫画网站大全, 免费韩漫, 韩漫在线看';

    document.title = title;

    const setMeta = (name: string, content: string, attrName: string = 'name') => {
      let el = document.querySelector(`meta[${attrName}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attrName, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', `${keywords}, ${baseKeywords}`);
    if (canonicalUrl) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonicalUrl);
    }

    setMeta('og:type', ogType, 'property');
    setMeta('og:title', title, 'property');
    setMeta('og:description', description, 'property');
    setMeta('og:url', canonicalUrl || '', 'property');
    setMeta('og:site_name', '韩国漫画网', 'property');
    setMeta('og:locale', 'zh_CN', 'property');
    if (ogImage) setMeta('og:image', ogImage, 'property');

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
    if (ogImage) setMeta('twitter:image', ogImage);
  }, [title, description, keywords, canonicalUrl, ogType, ogImage]);

  return null;
}